import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { NoteDTO } from "../../../api/api";
import type { AgentResponse } from "./agentsApi";
import { updateAgentNotes } from "./agentsApi";

export const useUpdateAgentNotes = (agentId: string) => {
  const queryClient = useQueryClient();

  const updateAgentNotesMutation = useMutation<AgentResponse, unknown, NoteDTO[]>({
    mutationFn: (notes) => updateAgentNotes(agentId, notes),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["agents", agentId] });
      await queryClient.invalidateQueries({ queryKey: ["agents"] });
    },
  });

  return {
    updateNotes: (notes: NoteDTO[]) => updateAgentNotesMutation.mutateAsync(notes),
  };
};
